// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';
import { CERTIFICATION_PAST_DUE_DEFINITIONS } from 'constants/affordableCertificationPastDueDefinitions';
import { getCertificationPastDueDefinitionOptions } from '../utils';
// Components
import {
  Grid,
  SingleSelect,
} from '@fortress-technology-solutions/fortress-component-library/Molecules';
import { AlertInfoIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import useIntl from 'hooks/useIntl';

type Props = {
  editMode: boolean,
  value?: string,
  name: string,
  onChange: Function,
};

const CertificationPastDue = ({
  editMode,
  value,
  name,
  onChange,
}: Props): React$Node => {
  const intl = useIntl();

  const handleCertificationPastDueChange = (newValue: string) => {
    onChange({
      target: {
        name,
        value: newValue,
      },
    });
  };

  return (
    <Grid item xs={12} sm={6}>
      <SingleSelect
        label={
          <FormattedMessage {...messages.certificationPastDueDefinition} />
        }
        InputLabelProps={{
          TooltipProps: {
            title: (
              <FormattedMessage
                {...messages.certificationPastDueDefinitionTooltip}
              />
            ),
            children: <AlertInfoIcon />,
          },
        }}
        readOnly={!editMode}
        name={name}
        value={value ?? CERTIFICATION_PAST_DUE_DEFINITIONS.FIRST_OF_MONTH_DUE}
        options={getCertificationPastDueDefinitionOptions(intl, messages)}
        onChange={handleCertificationPastDueChange}
      />
    </Grid>
  );
};

export default CertificationPastDue;
